import { AxiosError, AxiosResponse } from "axios";
import { defineModule } from "direct-vuex";
import { moduleActionContext } from "..";
import { axiosInstance } from "../../plugins/axios";

export interface TransporeonModuleStateInterface {
    transporeonIntegrationStates: any[];
}

const trackingModule = defineModule({
    namespaced: true,
    state: {
        transporeonIntegrationStates: [
            //{ stateName: "ARRIVE", state: "ARRIVE", source: "all" },
            { stateName: "COLLECT", state: "COLLECT", source: "loading" },
            { stateName: "DELIVER", state: "DELIVER", source: "unloading" },
            { stateName: "POD", state: "DEPART", source: "unloading" },
            { stateName: "DELIVER + POD", state: "DELIVER_POD", source: "unloading" },
        ],
    } as TransporeonModuleStateInterface,
    mutations: {
    },
    actions: {
        confirmTransporeonTransportOrder(context, payload: { supervisorId: number, customerCompanyId: number, saleValueCurrency: string, paymentTermSale: number | null, isPayerRequired: boolean, payerId: number | null }) {
            const { rootState, rootDispatch } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/transporeon/confirm-transporeon-transport-order/" + payload.supervisorId, {
                        customerCompanyId: payload.customerCompanyId,
                        saleValueCurrency: payload.saleValueCurrency,
                        paymentTermSale: payload.paymentTermSale,
                        isPayerRequired: payload.isPayerRequired,
                        payerId: payload.payerId
                    })
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                        if (resp.data.isSuccess) {
                            rootState.supervisor.supervisor.isTransporeonTransportOrderConfirmed = true;

                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: "Potwierdzenie zlecenia transporeon",
                                message: "Zlecenie transportowe zostało potwierdzone.",
                                links: [],
                                options: { buttonColor: "primary", layoutColor: "primary" },
                                buttonType: "ok"
                            });
                        }
                        else {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: "Potwierdzenie zlecenia transporeon",
                                message: "BŁĄD: " + resp.data.errorMessage,
                                links: [],
                                options: { buttonColor: "error", layoutColor: "error" },
                                buttonType: "ok"
                            });
                        }
                        return resp.data
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
        async mergeSupervisorWithSupervisorFromTranporeonTransportOrder(context, payload: { baseSupervisorId: number, transporeonSupervisorId: number }) {
            const { rootDispatch } = _moduleActionContext(context);
            return await new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/transporeon/merge-supervisor-with-supervisor-from-tranporeon-transport-order/" + payload.baseSupervisorId + "/" + payload.transporeonSupervisorId)
                    .then(async (resp: AxiosResponse) => {
                        resolve(resp.data);
                        if (resp.data.isSuccess) {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: "Scalanie zlecenia Transporeon",
                                message: "Scalanie zlecenia Transporeon zostało wykonane.",
                                links: [],
                                options: { buttonColor: "primary", layoutColor: "primary" },
                                buttonType: "ok"
                            });
                            await rootDispatch.supervisor.loadSupervisor({ id: payload.baseSupervisorId });
                        }
                        else {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: "Scalanie zlecenia Transporeon",
                                message: "BŁĄD: " + resp.data.errorMessage,
                                links: [],
                                options: { buttonColor: "error", layoutColor: "error" },
                                buttonType: "ok"
                            });
                        }
                        return resp.data
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        }
    }
});

export default trackingModule;
const _moduleActionContext = (context: any) => moduleActionContext(context, trackingModule)